import { render, staticRenderFns } from "./CompanyCourseExtendList.vue?vue&type=template&id=67c8eb7c&scoped=true"
import script from "./CompanyCourseExtendList.vue?vue&type=script&lang=js"
export * from "./CompanyCourseExtendList.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourseExtendList.vue?vue&type=style&index=0&id=67c8eb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8eb7c",
  null
  
)

export default component.exports